//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
} from "../../../helpers/fakebackend_helper";
import { Dispatch } from "redux";
import { LoginPayload, LoginResponse, ApiError } from "../../../interface";
import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
} from "./reducer";
import { login } from "api/apis";

// export const loginUser = (user: any, router: any) => async (dispatch: any) => {

//   try {
//     let response;
//     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
//       let fireBaseBackend = getFirebaseBackend();
//       response = fireBaseBackend.loginUser(
//         user.email,
//         user.password
//       );
//     } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
//       response = postJwtLogin({
//         email: user.email,
//         password: user.password
//       });

//     } else if (process.env.REACT_APP_DEFAULTAUTH) {
//       response = postFakeLogin({
//         email: user.email,
//         password: user.password,
//       });
//     }

//     var data = await response;
//     if (data) {
//       localStorage.setItem("authUser", JSON.stringify(data));
//       if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
//         var finallogin: any = JSON.stringify(data);
//         finallogin = JSON.parse(finallogin)
//         data = finallogin.data;
//         if (finallogin.username && finallogin.password) {
//           dispatch(loginSuccess(data));
//           router("/")
//         } else {
//           dispatch(apiError(finallogin));
//         }
//       } else {
//         dispatch(loginSuccess(data));
//         router("/")
//       }
//     }
//   } catch (error) {
//     dispatch(apiError(error));
//   }
// };

export const loginUser =
  (user: LoginPayload, router: any) => async (dispatch: Dispatch) => {
    try {
      const response = await login(user);
      const data = response.data as LoginResponse;

      if (data && data.success) {
        localStorage.setItem("authUser", JSON.stringify(data));
        dispatch(loginSuccess(data));
        router("/"); // Navigate to home/dashboard
      } else {
        dispatch(apiError({ error: "Invalid login response" }));
      }
    } catch (err: any) {
      dispatch(apiError(err.response?.data as ApiError));
    }
  };

export const logoutUser = () => async (dispatch: any) => {
  try {
    localStorage.removeItem("authUser");
    const fireBaseBackend = getFirebaseBackend();
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = fireBaseBackend.logout;
      dispatch(logoutUserSuccess(response));
    } else {
      dispatch(logoutUserSuccess(true));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin =
  (type: any, history: any) => async (dispatch: any) => {
    try {
      let response;

      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const fireBaseBackend = getFirebaseBackend();
        response = fireBaseBackend.socialLoginUser(type);
      }
      //  else {
      //   response = postSocialLogin(data);
      // }

      const socialdata = await response;
      if (socialdata) {
        localStorage.setItem("authUser", JSON.stringify(socialdata));
        dispatch(loginSuccess(socialdata));
        history("/dashboard");
      }
    } catch (error) {
      dispatch(apiError(error));
    }
  };

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
